import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, MessageCircleDashed as MessageCircle } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY < 10) {
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY) {
        // Scrolling down
        setIsVisible(false);
        setIsOpen(false);
      } else {
        // Scrolling up
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    setIsVisible(true);
    setLastScrollY(0);
  }, [location.pathname]);

  const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'About Us', path: '/about' },
  { name: 'Gallery', path: '/gallery' },
  { name: 'Contact', path: '/contact' }];


  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className={`bg-white shadow-2xl sticky top-0 z-50 border-b-4 border-[#4682B4] transition-transform duration-300 ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top Row - Logo Centered */}
        <div className="flex justify-center py-4 border-b-2 border-[#E0E0E0]">
          <Link to="/" className="group">
            <div className="relative transition-all duration-300 group-hover:scale-105">
              <img
                src="https://static.lumi.new/material/66/66a4c27753fb25abc1c6c422f1a19e87.jpeg"
                alt="ONPOINT Mobile Mechanics Logo - Professional Mobile Auto Repair"
                className="h-24 w-auto object-contain drop-shadow-2xl"></img>

            </div>
          </Link>
        </div>

        {/* Bottom Row - Navigation & CTAs */}
        <div className="flex justify-between items-center h-16">
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8 flex-1 justify-center">
            {navLinks.map((link) =>
            <Link
              key={link.path}
              to={link.path}
              className={`text-base font-bold transition-all px-4 py-2 rounded-lg ${
              isActive(link.path) ?
              'text-white bg-[#4682B4] shadow-lg' :
              'text-[#333333] hover:text-[#4682B4] hover:bg-[#E0E0E0]'}`
              }>

                {link.name}
              </Link>
            )}
          </div>

          {/* Desktop CTA Buttons */}
          <div className="hidden md:flex items-center space-x-3">
            <a
              href="tel:07454922145"
              className="bg-[#FFD700] text-[#333333] px-5 py-2.5 rounded-lg font-bold hover:bg-[#4682B4] hover:text-white transition-all flex items-center space-x-2 shadow-lg hover:shadow-xl"
              aria-label="Call ONPOINT Mobile Mechanics at 07454 922145">

              <Phone className="w-5 h-5" />
              <span>Call Now</span>
            </a>
            <a
              href="https://wa.me/447308538351"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#4682B4] text-white px-5 py-2.5 rounded-lg font-bold hover:bg-[#FFD700] hover:text-[#333333] transition-all flex items-center space-x-2 shadow-lg hover:shadow-xl"
              aria-label="Message ONPOINT Mobile Mechanics on WhatsApp">

              <MessageCircle className="w-5 h-5" />
              <span>WhatsApp</span>
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-[#333333] hover:text-[#4682B4] transition-colors ml-auto"
            aria-label="Toggle mobile menu">

            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen &&
        <div className="md:hidden pb-4 bg-[#E0E0E0]">
            <div className="flex flex-col space-y-3 p-4">
              {navLinks.map((link) =>
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setIsOpen(false)}
              className={`text-base font-bold py-3 px-4 rounded-lg transition-all ${
              isActive(link.path) ?
              'text-white bg-[#4682B4] shadow-lg' :
              'text-[#333333] hover:bg-white'}`
              }>

                  {link.name}
                </Link>
            )}

              {/* Mobile CTA Buttons */}
              <div className="flex flex-col space-y-2 pt-4">
                <a
                href="tel:07454922145"
                className="bg-[#FFD700] text-[#333333] px-4 py-3 rounded-lg font-bold hover:bg-[#4682B4] hover:text-white transition-all flex items-center justify-center space-x-2 shadow-lg"
                aria-label="Call ONPOINT Mobile Mechanics at 07454 922145">

                  <Phone className="w-5 h-5" />
                  <span>Call 07454 922145</span>
                </a>
                <a
                href="https://wa.me/447308538351"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#4682B4] text-white px-4 py-3 rounded-lg font-bold hover:bg-[#FFD700] hover:text-[#333333] transition-all flex items-center justify-center space-x-2 shadow-lg"
                aria-label="Message ONPOINT Mobile Mechanics on WhatsApp">

                  <MessageCircle className="w-5 h-5" />
                  <span>WhatsApp Us</span>
                </a>
              </div>
            </div>
          </div>
        }
      </div>
    </nav>);

};

export default Navbar;